// eslint-disable-next-line import/no-import-module-exports
import React from 'react';

const _ = require('./i18n');
const LoadingComponent = require('./generic/loading');

class VisitedPages extends LoadingComponent {
  constructor(props) {
    super(props);

    this.state = { item_list: [], ...this.state };
    this.dataUrl = '/widgets/visited-pages/';
  }

  capfirst(str) {
    if (!str) return str;
    return str[0].toUpperCase() + str.slice(1);
  }

  render() {
    if (!this.shouldRender() || !this.state.item_list.length) { return null; }

    return (
      <div className="visited-pages">
        <header className="visited-pages-header">
          <h4 className="visited-pages-title">{_('Visited pages')}</h4>
        </header>

        <ul className="visited-pages-list">
          {this.state.item_list.map(([title, url], idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <li className="visited-pages-item" key={`visited-item-${idx}`}>
              <a href={url} title={this.capfirst(title)} className="visited-pages-item-link">
                <span>{this.capfirst(title)}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

module.exports = VisitedPages;
